import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://unlockedtutoring.com.au';

interface SeoProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
  /** Open Graph type. Defaults to "website"; use "article" for guides/posts. */
  type?: 'website' | 'article';
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Per-route head tags. Social crawlers that don't run JS still see the
 * sitewide og:* fallbacks in index.html.
 */
export function Seo({ title, description, path, noindex, type = 'website', jsonLd }: SeoProps) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}

export default Seo;